import { message } from "antd";
import React, { useEffect, useState } from "react";
import { departmentDetailService } from "Services/AdminServices/Organization/DepartmentDetailService";

export const useDepartmentDetail = (departmentId) => {
  const [department, setDepartment] = useState(null);
  const [departments, setDeaprtments] = useState([]);
  const [loadingDept, setLoadingDept] = useState(false);
  const [ loadingCareerPaths, setLoadingCareerPaths] = useState(false);
  const [loadingJobs, setLoadingJobs] = useState(false);
  const [loadingDepts, setLoadingDepts] = useState(false);
  const [loadingEditJob, setLoadingEditJob] = useState(false);
  const [ careerPaths, setCareerPaths ] = useState([]);
  const [ careerPathsLoaded , setCareerPathsLoaded ] = useState(false);
  const [jobTitles, setJobTitles] = useState([]);
  const [jobTitle, setJobTitle] = useState(null);
  const [jobTitlesLoaded, setJobTitlesLoaded] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [employeesLoaded, setEmployeesLoaded] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    departmentId: parseInt(departmentId) || 0, // make sure it's a number
  });

  const createJobTitle = async (payload) => {
    try {
      const response = await departmentDetailService.createJobTitle(payload);
      return response;
    } catch (error) {
      const serverMessage =
        error?.response?.data?.details || error?.response?.data?.message || "Server Error";
      message.error(serverMessage);

      console.error("Error in creating Job Title", error);
    }
  };

  const updateJobTitle = async (payload) => {
    try {
      const response = await departmentDetailService.updateJobTitle(payload);
      return response;
    } catch (error) {
      console.error("Error in updating Job Title", error);
    }
  };

  const fetchDeaprtment = async (departmentId) => {
    try {
      setLoadingDept(true);
      const data = await departmentDetailService.getDepartmentDetail(departmentId);
      setDepartment(data);
    } catch (eror) {
      console.error("error in getting department detail");
    } finally {
      setLoadingDept(false);
    }
  };

  const fetchJobTitles = async (departmentId) => {
    try {
      setLoadingJobs(true);
      const data = await departmentDetailService.getJobTitles(departmentId);
      setJobTitles(data);
      setJobTitlesLoaded(true);
    } catch (error) {
      console.error("Error in fetching Job Titles", error);
    } finally {
      setLoadingJobs(false);
    }
  };

  const fetchCareerPaths = async (departmentId) => {
    try {
      setLoadingCareerPaths(true);
      const data = await departmentDetailService.getCareerPaths(departmentId);
      setCareerPaths(data);
      setCareerPathsLoaded(true);
    } catch (error) {
      console.error("Error in fetching Job Titles", error);
    } finally {
      setLoadingCareerPaths(false);
    }
  };

  const fetchJobTitle = async (jobTitleId) => {
    try {
      setLoadingEditJob(true);
      const data = await departmentDetailService.getJobTitle(jobTitleId);
      setJobTitle(data);
    } catch (error) {
      console.error("Error in fetching Job Title", error);
    } finally {
      setLoadingEditJob(false);
    }
  };

  const fetchDepartmentList = async () => {
    try {
      setLoadingDepts(true);
      const data = await departmentDetailService.getDepartmentList();
      setDeaprtments(data);
    } catch (error) {
      console.error("Error in loading departments", error);
    } finally {
      setLoadingDepts(false);
    }
  };

  const fecthEmployees = async (departmentId) => {
    try {
      setLoadingEmployees(true);
      const data = await departmentDetailService.getEmployess(departmentId);
      setEmployees(data);
    } catch (err) {
      throw err;
    } finally {
      setLoadingEmployees(false);
    }
  };

  const columns = [
    {
      title: "Employee ID",
      dataIndex: "publicId",
      key: "publicId",
    },
    {
      title: "Name",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      key: "departmentName",
      render: (text) => text || "-",
    },
    {
      title: "Designation",
      dataIndex: "designationName",
      key: "designationName",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Hire Date",
      dataIndex: "hiredDate",
      key: "hiredDate",
    },
  ];

  useEffect(() => {
    fetchDeaprtment(departmentId);
  }, [departmentId]);

  return {
    loadingDept,
    loadingJobs,
    department,
    jobTitles,
    fetchJobTitles,
    jobTitlesLoaded,
    formData,
    setFormData,
    createJobTitle,
    loadingDepts,
    departments,
    fetchDepartmentList,
    fetchJobTitle,
    jobTitle,
    loadingEditJob,
    updateJobTitle,
    fecthEmployees,
    loadingEmployees,
    employeesLoaded,
    employees,
    columns,
    careerPaths,
    loadingCareerPaths,
    careerPathsLoaded,
    fetchCareerPaths
  };
};
